"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IWallet = exports.paymentTypeMapper = exports.IPaymentInfoType = exports.IPaymentType = void 0;
const openapi_1 = require("../../../openapi");
const payrix_1 = require("../payrix");
var IPaymentType;
(function (IPaymentType) {
    IPaymentType["ACH"] = "ACH";
    IPaymentType["CC"] = "CC";
})(IPaymentType = exports.IPaymentType || (exports.IPaymentType = {}));
var IPaymentInfoType;
(function (IPaymentInfoType) {
    IPaymentInfoType["Visa"] = "Visa";
    IPaymentInfoType["MasterCard"] = "MasterCard";
    IPaymentInfoType["Amex"] = "Amex";
    IPaymentInfoType["BankAcc"] = "Bank Account";
    IPaymentInfoType["Diners"] = "Diners";
    IPaymentInfoType["Discover"] = "Discover";
})(IPaymentInfoType = exports.IPaymentInfoType || (exports.IPaymentInfoType = {}));
exports.paymentTypeMapper = {
    [payrix_1.ITokenPayment.AMERICAN_EXPRESS_1]: IPaymentInfoType.Amex,
    [payrix_1.ITokenPayment.VISA_2]: IPaymentInfoType.Visa,
    [payrix_1.ITokenPayment.MASTERCARD_3]: IPaymentInfoType.MasterCard,
    [payrix_1.ITokenPayment.DINERS_CLUB_4]: IPaymentInfoType.Diners,
    [payrix_1.ITokenPayment.DISCOVER_5]: IPaymentInfoType.Discover,
    [payrix_1.ITokenPayment.CHECKING_ACCOUNT_8]: IPaymentInfoType.BankAcc,
    [payrix_1.ITokenPayment.SAVINGS_ACCOUNT_9]: IPaymentInfoType.BankAcc,
    [payrix_1.ITokenPayment.CORPORATE_CHECKING_ACCOUNT_10]: IPaymentInfoType.BankAcc,
    [payrix_1.ITokenPayment.CORPORATE_SAVINGS_ACCOUNT_11]: IPaymentInfoType.BankAcc,
};
class IWallet {
    id;
    orgKey;
    customerId;
    isC2;
    addedBy; // email
    sharedWith; // email[],
    nickname;
    expirationDate;
    paymentType; // ACH || CC
    paymentInfo;
    paymentToken;
    paymentTokenId;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IWallet.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IWallet.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IWallet.prototype, "customerId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IWallet.prototype, "isC2", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'email' })
], IWallet.prototype, "addedBy", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string', format: 'email' } })
], IWallet.prototype, "sharedWith", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IWallet.prototype, "nickname", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IWallet.prototype, "expirationDate", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(IPaymentType) })
], IWallet.prototype, "paymentType", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'object',
        properties: {
            type: { type: 'string', enum: Object.values(IPaymentInfoType) },
            last4: { type: 'string' },
            firstName: { type: 'string' },
            lastName: { type: 'string' },
            zip: { type: 'string' },
        },
    })
], IWallet.prototype, "paymentInfo", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IWallet.prototype, "paymentToken", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IWallet.prototype, "paymentTokenId", void 0);
exports.IWallet = IWallet;
